const initialState = {
  toggleTutorialModal: false,
  videoListWithCategory: [],
  loadAllVideosPending: false,
  loadAllVideosError: null,
};

export default initialState;
